import { canUseDOM } from '@ps/web-core-utils';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useSetMitIdData = () => {
  const href = useSelector(select.location.getPathname);
  const query = useSelector(select.location.getQuery);

  const { mitid } = query;
  if (mitid && canUseDOM) {
    const mitIdData = Buffer.from(decodeURIComponent(mitid), 'base64').toString();
    window.history.replaceState({}, document.title, href);
    return Promise.resolve({
      mitIdResultContext: { extAuthToken: mitIdData }
    });
  } else {
    return Promise.resolve({});
  }
};

export default useSetMitIdData;
